import { isEmpty } from 'es-toolkit/compat';
import { core } from '@tock/coretypes';

export enum AccessOption {
  PUBLIC = 'PUBLIC',
  PRIVATE_LINK = 'PRIVATE_LINK',
  GUEST_GROUP = 'GUEST_GROUP',
  UNLISTED = 'UNLISTED',
}

export type ShortenedReadableAccessOption =
  | 'Not visible to guests'
  | 'All guests'
  | 'Private link'
  | 'Group';

export const AccessOptionToShortenedReadableMap: Record<
  AccessOption,
  ShortenedReadableAccessOption
> = {
  PUBLIC: 'All guests',
  PRIVATE_LINK: 'Private link',
  GUEST_GROUP: 'Group',
  UNLISTED: 'Not visible to guests',
};

export const getExperienceAccessOption = (experience: core.TicketType): AccessOption =>
  experience.unlisted
    ? AccessOption.UNLISTED
    : experience.hasPrivateUrl
    ? AccessOption.PRIVATE_LINK
    : !isEmpty(experience.guestProfileGroupId)
    ? AccessOption.GUEST_GROUP
    : AccessOption.PUBLIC;
